export class AssignHostsModel {
    public hostIds: Array<string>;
    public venueId: string;
  }